<template>
    <a-drawer placement="right" :closable="false" :visible="showDetail" @close="close" width="60%">
        <div class="page">
            <div class="title">
                <p>{{ formInfo.title }}</p>
                <span>{{ formInfo.startTime }} ~ {{ formInfo.endTime }}</span>
            </div>
            <!-- 问卷内容 -->
            <div class="question" style="padding: 0 15px 4px;">
                <div class="question-item" v-for="(item, index) in questionList" :key="index">
                    <b style="font-size: 16px;color: #1B1D26;;">第{{ index + 1 }}题</b>
                    <div class="content-item">
                        <div class="label">问题类型</div>
                        <div class="content">
                            <div class="ml12" style="height: 32px;line-height: 32px;">
                                {{ item.dataTypeText }}
                            </div>
                        </div>
                    </div>
                    <!-- 满意度 -->
                    <div v-show="item.dataType == 0">
                        <div class="content-item">
                            <div class="label">统计维度</div>
                            <div class="content">
                                <div class="ml12">{{ item.dimensionText }}</div>
                            </div>
                        </div>
                        <div class="content-item">
                            <div class="label">问题标题</div>
                            <div class="content">
                                <div class="ml12 etitle">
                                    {{ item.subjectText }}
                                    <a-badge v-if="item.averageValue" :count="'平均分：' + item.averageValue"
                                        :number-style="{ backgroundColor: '#40a9ff' }" class="ml12" />
                                </div>
                            </div>
                        </div>
                        <div style="display: flex; line-height: 32px;">
                            <!-- case -->
                            <div class="label">问题选项</div>
                            <div class="answers">
                                <div class="satisfaction" v-for="ele in item.itemCase"
                                    :class="{ 'tfy': item.itemCase[0].tags && item.itemCase[0].tags.length }"
                                    :key="ele.dataValue" style="display: flex;">
                                    <div class="satisfaction-title">
                                        {{ ele.dataValue }} &nbsp;{{ ele.caseName }}
                                        <a-badge v-if="ele.submitPercent" :count="ele.submitPercent + '%'"
                                            :number-style="{ backgroundColor: '#40a9ff' }" class="badge1" />
                                    </div>
                                    <div class="tag-box" style="width:calc(100vw - 100px);padding-top: 2px;">
                                        <div class="tag" v-for="(e, i) in ele.tags" :key="i" style="padding: 0 13px;">
                                            {{ e.caseName }}
                                            <a-badge v-if="e.submitPercent" :count="e.submitPercent + '%'"
                                                :number-style="{ backgroundColor: '#40a9ff' }" class="badge2" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- 单选及多选 -->
                    <div v-show="item.dataType == 10 || item.dataType == 20">
                        <div class="content-item">
                            <div class="label">问题标题</div>
                            <div class="content">
                                <div class="ml12 etitle">{{ item.subjectText }}</div>
                            </div>
                        </div>
                        <div class="content-item case" style="width: 52vw;">
                            <div class="label">问题选项</div>
                            <div class="tag-box" style="transform: translateY(-10px);">
                                <div class="tag" v-for="(e, i) in item.storageTags" :key="i">
                                    {{ e.caseName }}
                                    <a-badge v-if="e.submitPercent" :count="e.submitPercent + '%'"
                                        :number-style="{ backgroundColor: '#40a9ff' }" class="badge2" />
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- 自定义文本 -->
                    <div v-show="item.dataType == 30">
                        <div class="content-item">
                            <div class="label">问题标题</div>
                            <div class="content">
                                <div class="ml12 etitle">{{ item.subjectText }}</div>
                            </div>
                        </div>
                    </div>
                    <div class="content-item" style="margin-top: -2px">
                        <div class="label">是否必填</div>
                        <div class="content">
                            <div v-show="!item.editing">
                                <a-checkbox style="margin: 0 8px 0 12px;" v-model="item.requiredFlag" disabled>
                                </a-checkbox>必填
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </a-drawer>
</template>

<script>
import moment from 'moment';
import questionnaire from '../../../api/questionnaire';
import school from '../../../api/school';
import Vue from 'vue';
const typeList = [
    {
        value: 0,
        label: '单选1-5满意度',
    },
    {
        value: 10,
        label: '单选题',
    },
    {
        value: 20,
        label: '多选题',
    },
    {
        value: 30,
        label: '问答题',
    },
];
export default {
    name: "QTableDetail",
    props: {
        showDetail: {
            type: Boolean,
            default: false,
        },
        classId: {
            type: Number
        },
        formId: {
            type: Number
        },
    },
    data() {
        return {
            typeList,
            formInfo: '',
            questionList: [],
            dimension: [],
        }
    },
    created() {
        // console.log(this.id, 'id');
        this.getFormInfo();
        this.getQuestionList();
    },
    methods: {
        async getFormInfo() {
            const { data } = await questionnaire.getQuestionnaireDetail(this.formId)
            if (!data) return
            this.formInfo = data
            this.formInfo.startTime = moment(data.startTime).format('YYYY-MM-DD')
            this.formInfo.endTime = moment(data.endTime).format('YYYY-MM-DD')
        },
        // 获取维度
        async getDimensionList() {
            const { data } = await questionnaire.getDimension()
            if (!data) return
            this.dimension = data
        },
        // 获取问题列表
        async getQuestionList() {
            await this.getDimensionList()
            let params = {
                id: this.formId,
                schoolId: Vue.ls.get('schoolId'),
                classId: this.classId,
            }
            const { data } = await questionnaire.getClassQuestionList(params)
            if (!data.id) return
            this.questionList = data.item ? data.item : []
            this.transformData()
            // console.log(this.questionList, '处理完')
            this.$forceUpdate()
        },
        // 处理数据
        transformData() {
            this.questionList.forEach((item, index) => {
                item.subjectText = item.subject
                item.dataTypeText = this.typeList.find(e => e.value == (item.dataType == 35 ? 30 : item.dataType)).label
                item.requiredFlag = item.required == 1 ? true : false
                if (item.dataType == 0) {
                    item.itemCase.forEach(e => {
                        e.inputVisible = false
                        e.inputTag = ''
                    })
                    item.tagList = []
                    item.itemCase.forEach(e => {
                        item.tagList.push(e.tags ? e.tags : [])
                    })
                    item.dimensionText = this.dimension.find(e => e.id == item.dimensionId).dimensionTitle
                }
                if (item.dataType == 10 || item.dataType == 20) {
                    item.copyCase = JSON.parse(JSON.stringify(item.itemCase))
                    item.storageTags = item.itemCase.map(e => {
                        return {
                            submitPercent: e.submitPercent,
                            caseName: e.caseName,
                        }
                    })
                    item.itemCase.find((e, i) => {
                        if (e.dataType == 30) {
                            item.haveOther = true
                            item.otherId = e.id
                            item.itemCase.splice(i, 1)
                        }
                    })
                }

            })
        },
        // 关闭详情抽屉
        close() {
            this.$emit("update:showDetail", false);
        },
    }
}
</script>

<style lang="less" scoped>
::v-deep .ant-drawer-body {
    padding: 0;
}

.title {
    padding: 33px 0 29px 20px;
    width: 100%;
    margin-bottom: 12px;
    font-family: PingFangSC, PingFang SC;
    background: #fff url(https://static.khsdb.com/images/evbg.png) no-repeat;
    border-bottom: #edf3ef solid 4px;

    p {
        font-family: PingFangSC, PingFang SC;
        font-size: 18px;
        font-weight: 600;
        color: #1B1D26;
        line-height: 25px;
        margin-bottom: 6px;
    }

    span {
        font-size: 14px;
        color: #8d8f92;
    }
}

.question-item {
    width: 100%;
    padding: 20px;
    margin-bottom: 16px;
    border-radius: 4px;
    background-color: #fff;
    border: 1px solid rgba(126, 134, 142, 0.16);

    .label {
        margin-right: 16px;
        min-width: 56px
    }

    .content-item {
        width: 512px;
        padding: 2px 0;
        margin-bottom: 12px;
        display: flex;
        align-items: center;

        .content {
            flex: 1;
        }
    }

    .case {
        align-items: start;
        line-height: 32px;
    }

    .answers {
        width: 47vw;

        .satisfaction {
            display: flex;
            align-items: center;
            flex: 1;
            margin-bottom: 10px;

            .satisfaction-title {
                position: relative;
                width: 92px;
                margin: 0 26px 0 12px;
            }

            .satisfaction-tags {
                flex: 1;
                border-radius: 4px;
                border: 1px solid rgba(126, 134, 142, 0.16);
                padding-left: 13px;
                overflow: hidden;
            }
        }
    }

}

.tfy {
    transform: translateY(-6px) !important;
}

.ml12 {
    margin-left: 12px;
}

.tag-box {
    display: flex;
    justify-content: flex-start;
    flex-wrap: wrap;
    margin-left: 12px;
    flex: 1;
    width: 800px;
    transform: translateY(-5px);

    .tag {
        position: relative;
        font-size: 14px;
        padding: 0px 27px;
        height: 32px;
        line-height: 30px;
        margin: 10px 13px 0 0;
        border-radius: 4px;
        border: 1px solid rgba(126, 134, 142, 0.16);
    }
}

.etitle {
    display: flex;
    align-items: center;
    width: calc(60vw - 192px);
}

.badge1 {
    position: absolute;
    right: -35px;
    top: -4px;
}

.badge2 {
    position: absolute;
    right: -14px;
    top: -12px;
}

::v-deep .ant-drawer-mask {
    background-color: transparent;
}
</style>